import { render, staticRenderFns } from "./CartaoDeCliente.vue?vue&type=template&id=7502e5fd&scoped=true"
import script from "./CartaoDeCliente.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeCliente.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeCliente.vue?vue&type=style&index=0&id=7502e5fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7502e5fd",
  null
  
)

export default component.exports